import { colors } from '@mm/utils';
import React, { CSSProperties } from 'react';
import MDSpinner from 'react-md-spinner';

export type SpinnerProps = {
  show?: boolean;
  size?: number;
  position?: CSSProperties['position'];
  backgroundColor?: string;
  className?: string;
  color?: string;
  standalone?: boolean;
  width?: CSSProperties['width'];
  children?: React.ReactNode;
};

export const Spinner = (props: SpinnerProps) => {
  const { show, className, standalone, children } = props;
  const size = props.size || 24;
  const width = props.width || '100%';
  let position = props.position || 'fixed';
  let backgroundColor = props.backgroundColor || 'rgba(0, 0, 0, 0.2)';
  let color = props.color || '#2f54eb';

  if (standalone) {
    color = colors.accentBlue;
    position = 'relative';
    backgroundColor = 'transparent';
  }

  const styleSheet = {
    flexContainer: {
      display: show || standalone ? 'flex' : 'none',
      position,
      justifyContent: 'center',
      alignItems: 'center',
      width,
      height: '100%',
      zIndex: 1000,
      backgroundColor,
    },
  };

  const spinner = (
    <div style={styleSheet.flexContainer} className={className}>
      <MDSpinner size={size} singleColor={color} duration={1100} />
    </div>
  );
  return children ? (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {spinner}
      <div style={{ marginLeft: size / 4, flex: 'none' }}>{children}</div>
    </div>
  ) : (
    spinner
  );
};
